class Food {
  constructor() {
    this.type = "Food";
  }
}

export default Food;
